import DefaultActionManager from "../action_managers/default_action_manager";
import UserStore from "../lib/user_store";

export const adminLoginAsActionPrefix = "ADMIN_LOGIN_AS";

class AdminLoginAsActionManager extends DefaultActionManager {
  responseOK(dispatch, json) {
    const user = json.user || json;
    const admin = json.admin;
    UserStore.save(user, { admin: true, ...(admin && { adminToken: admin.authToken }) });
    super.responseOK(dispatch, user);
  }
}

export function adminLoginAs(body) {
  return new AdminLoginAsActionManager({
    auth: false,
    route: "users/login-as",
    actionName: adminLoginAsActionPrefix,
    body: body,
    method: "post",
  }).run();
}
